<ng-container *ngTemplateOutlet="config.usePOC ? POCtlp : currentTpl"></ng-container>

<ng-template #currentTpl>
  <div class="cp-dialog-overlay" [ngClass]="accountCenterClassModifier()" (click)="onOverlayClicked($event)">
    <div class="cp-dialog-dialog" [ngClass]="config ? config.extraClasses : ''" (click)="onDialogClicked($event)">
      <ng-template cpDialogInsertion></ng-template>
    </div>
  </div>
</ng-template>

<ng-template #POCtlp>
  <div class="cp-dialog-overlay__POC" [ngClass]="accountCenterClassModifierPOC()" (click)="onOverlayClicked($event)">
    <div
      class="cp-dialog__POC"
      [ngClass]="['cp-dialog__POC--' + config.size, config.extraClasses || '']"
      (click)="onDialogClicked($event)"
    >
      <div class="cp-dialog__POC__toolbar" *ngIf="!config.disableClose">
        <button class="cp-dialog__POC__close-button" (click)="close($event)">
          <cp-icon type="close"></cp-icon>
        </button>
      </div>

      <ng-template cpDialogInsertion></ng-template>
    </div>
  </div>
</ng-template>
